/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useFacetsState, FACET_STATE } from 'hooks/useFacetsState';
import { FacetItem } from '../../../components/facets/facetItem';

/**
 * Handles the rendering of a single facet
 * @param {string} propertyName
 * @param {string} facetName
 * @param {string} facetKey
 * @param {number} facetActiveValue
 * @param {number} facetTotalValue
 */
export const FacetDetail = ({
	propertyName,
	facetName = 'n/a',
	facetKey,
	facetActiveValue = 0,
	facetTotalValue = 0,
	...props
}) => {
	const { toggleExcludeFacet, toggleFacet, getFacetState, getTextFilter } = useFacetsState();
	const state = getFacetState(propertyName, facetKey);
	const textFilter = getTextFilter();
	const isSelected = state === FACET_STATE.ON;
	const isExcluded = state === FACET_STATE.OFF;

	const toggleSelected = () => { toggleFacet(propertyName, facetKey) };

	const toggleExcluded = () => { toggleExcludeFacet(propertyName, facetKey) }

	return (
		<FacetItem
			facetCheckboxProps={{
				isSelected,
				isExcluded
			}}
			facetCountProps={{
				set: facetActiveValue,
				total: facetTotalValue
			}}
			facetName={facetName}
			facetTextFilter={textFilter}
			onClickSelect={toggleSelected}
			onClickExclude={toggleExcluded}
			{...props}
		/>
	);
};

